/**
 * Application Configuration Constants
 * รวมการตั้งค่าหลักของแอพไว้ที่เดียว
 */

// SEO Title สำหรับ ติวหมอไทย - ใช้ในทุกหน้าเพื่อ SEO
export const NURSE_APP_TITLE = 'ติวหมอไทย - แอปติวสอบใบประกอบวิชาชีพแพทย์แผนไทย | เภสัชกรรมไทย เวชกรรมไทย นวดไทย ผดุงครรภ์ไทย | ข้อสอบจริงกว่า 1,000+ ข้อ | วิเคราะห์จุดอ่อน-จุดแข็ง | เรียนแบบเกม สนุก ไม่เบื่อ';

// App Name
export const APP_NAME = 'ติวหมอไทย';

// App Description
export const APP_DESCRIPTION = 'แอปติวสอบใบประกอบวิชาชีพแพทย์แผนไทย | เภสัชกรรมไทย เวชกรรมไทย นวดไทย ผดุงครรภ์ไทย | ข้อสอบจริงกว่า 1,000+ ข้อ';

// App Keywords สำหรับ SEO
export const APP_KEYWORDS = 'ติวหมอไทย, ติวสอบแพทย์แผนไทย, เภสัชกรรมไทย, เวชกรรมไทย, นวดไทย, ผดุงครรภ์ไทย, ข้อสอบแพทย์แผนไทย, แอปติวสอบ, Thai traditional medicine, exam prep, gamification';



